import SelectedTreatmentPdf from './SelectedTreatmentPdf';

export default SelectedTreatmentPdf;
